// Tokens used across the app for the "day/month/year segment ordering"
// preference (user, company, and global-default cascade). Grep for
// `DATE_PART_ORDER_` to find all producers/consumers.
export const DATE_PART_ORDER_DMY = 'DMY';
export const DATE_PART_ORDER_MDY = 'MDY';
export const DATE_PART_ORDER_YMD = 'YMD';

export type DatePartOrder =
  | typeof DATE_PART_ORDER_DMY
  | typeof DATE_PART_ORDER_MDY
  | typeof DATE_PART_ORDER_YMD;

export interface DateTimeFormat {
  dateTimeWithStringMonth?: string;
  dateWithStringMonth?: string;
  hoursMinutesMeridiem?: string;
  hoursMinutesMeridiemWithTimezone?: string;
  longSlashDate?: string;
  shortSlashDateWithLongYear?: string;
  slashDateTime?: string;
  slashDateTimeWithZoneFormat?: string;
  slashDateTimeWithZoneShortYear?: string;
  slashMonthsYearsOnly?: string;
  spacedSlashDate?: string;
  spacedSlashedDateTimeWithZoneFormat?: string;
  unix_dash_date_time_with_zone?: string;
}

export interface GlobalDateTimeFormats {
  default_date_part_order: DatePartOrder | string;
  ordered_formats: {
    [key: string]: DateTimeFormat;
  };
}

export interface GlobalLotsUiConfigKeys {
  [key: string]: string;
  collect_items_per_unit: string;
  set_baseline_average_on_first_round_quotes: string;
  show_discount: string;
  show_extended_price_feedback: string;
  show_logistics_charge: string;
  show_pricing_columns: string;
  show_suggested_price_column: string;
}

export interface GlobalRequestsUiConfigLots {
  [key: string]: boolean;
  collect_items_per_unit: boolean;
  set_baseline_average_on_first_round_quotes: boolean;
  show_pricing_columns: boolean;
}

export interface Global {
  /** Event scheduling defaults from config/global/bidding_events.yml, narrowed to what is used. */
  bidding_events: {
    default_options: {
      should_skip_weekends: boolean;
    };
    round_types: {
      break: string;
      price_guidance: string;
      price_match: string;
      pricing: string;
      review: string;
    };
  };
  date_time_formats: GlobalDateTimeFormats;
  line_items: {
    defaults: {
      extended_quantity: number,
      max_line_items_rendered_count: number
      name: string,
      numeric_question: { qualifying_equality: string },
      price: string,
      quantity: number,
      sno: number,
      units: string,
      yes_no_question: {
        qual_question_type: string,
        qualifying_answer_text: string
      }
    }
  },
  loadable: {
    status: {
      final_statuses: string[];
    },
  },
  lots: {
    custom_column_headers: {
      column_types: {
        adder: string;
        descriptive: string;
        qualifying: string;
      };
      data_types: {
        numeric: string;
        text: string;
      }
    },
    ui_config_keys: GlobalLotsUiConfigKeys;
  },
  passwords: {
    max_length: number;
    min_length: number;
  },
  requests: {
    ui_config: {
      lots: GlobalRequestsUiConfigLots;
    }
  },
}
